import { Tooltip } from '@/components/tooltip.js';
import { Checkbox } from '@/components/ui/checkbox.js';
import { getAdminSessions, updateSessionGoogleMeetChecked } from '@/lib/api-calls.js';
import { AdminSession, VideoConferenceType } from '@airreading/common/data';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type CheckboxGoogleMeetCheckedProps = AdminSession & {
  checkboxTestId?: string;
};

export function CheckboxGoogleMeetChecked({ checkboxTestId, ...props }: CheckboxGoogleMeetCheckedProps) {
  const { id, videoConferenceType, googleMeet } = props;
  const queryClient = useQueryClient();
  const { mutateAsync: updateChecked } = useMutation({ mutationFn: updateSessionGoogleMeetChecked });

  const isGoogleMeet = videoConferenceType === VideoConferenceType.googleMeet;
  const checked = !!googleMeet?.checkedAt;

  const onCheckedChange = async () => {
    await updateChecked({ sessionId: id, checked: !checked });
    queryClient.invalidateQueries(getAdminSessions());
  };

  if (!isGoogleMeet) {
    return (
      <Tooltip trigger={<Checkbox checked={false} disabled aria-label="Google Meet checked" />}>
        Only for Google Meet sessions
      </Tooltip>
    );
  }

  return (
    <Tooltip
      trigger={
        <Checkbox
          checked={checked}
          onCheckedChange={onCheckedChange}
          aria-label="Google Meet checked"
          data-testid={checkboxTestId}
        />
      }
    >
      {checked ? 'Marked as checked' : 'Mark as checked'}
    </Tooltip>
  );
}
